export default "__VITE_ASSET__Co43GHP2__"